// extracted by mini-css-extract-plugin
module.exports = {"grid-inductees":"GridInductees_grid-inductees__8OJWH","grid":"GridInductees_grid__Zzhxz","inductee-item":"GridInductees_inductee-item__Q42hp","cta":"GridInductees_cta___Mxmn"};